import { Show } from '@welbe/web-design-system';
import HomeIcon from 'App/assets/img/home-gray.svg?url';
import HeaderPage from 'App/Components/HeaderPage';
import { CompanyPermissions } from 'constants/companyPermissions';
import { BrokersContext } from 'contexts/Brokers/Brokers';
import { I18nProviderContext } from 'contexts/I18nProvider';
import { useAnalyticsOpenScreen } from 'hooks/useAnalyticsOpenScreen';
import { useSessionStorage } from 'hooks/useSessionStorage';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
	checkFunctionalityPermission,
	checkHRAPermission,
} from 'utils/checkFunctionalityPermission';
import { Card } from './components/Card/Card';
import { cardsConfig } from './Home.constants';
import { Container, Content, ContentCards, Title } from './Home.style';
import { PermissionKey } from './Home.types';

export const Home = (): JSX.Element => {
	const navigate = useNavigate();
	const { getSessionStorage } = useSessionStorage();
	const sessionStorage: any = getSessionStorage('me');
	const username = JSON.parse(sessionStorage);
	const { isBroker } = useContext(BrokersContext);
	const { translate } = useContext(I18nProviderContext);

	useAnalyticsOpenScreen({
		context: 'home',
		trackName: 'Open Home',
		analyticProps: { isBroker },
	});

	const permissions: Record<PermissionKey, boolean> = {
		dashboard: checkFunctionalityPermission(CompanyPermissions.dashboard.id),
		employees: checkFunctionalityPermission(CompanyPermissions.employees.id),
		candidates: checkFunctionalityPermission(CompanyPermissions.candidates.id),
		nom035: checkFunctionalityPermission(CompanyPermissions.nom035.id),
		hra: checkHRAPermission(),
		users: checkFunctionalityPermission(CompanyPermissions.users.id),
		jobProfiles: checkFunctionalityPermission(
			CompanyPermissions.jobProfiles.id,
		),
	};

	return (
		<Container>
			<HeaderPage icon={HomeIcon} title={translate('home.title')} />
			<Content>
				<Title>{`¡Bienvenido ${username.name}!`}</Title>
				<ContentCards>
					{cardsConfig.map(({ id, img, title, text, path }) => {
						const permission = permissions[id];
						return (
							<Show
								key={id}
								when={!permission && !img.disabled}
								fallback={
									<Card
										onClick={() => permission && navigate(path)}
										disabled={!permission}
										img={permission ? img.enabled : img.disabled}
										title={translate(title)}
										text={translate(text)}
										id={id}
									/>
								}
							>
								{null}
							</Show>
						);
					})}
				</ContentCards>
			</Content>
		</Container>
	);
};
